import { Link } from "react-router-dom";

function TantramassageNavigation() {
    return (
        <nav
            className="subnav"
            aria-label="Tantramassage Navigation"
        >
            <ul className="subnav-list">

                <li>
                    <Link
                        className="subnav__link"
                        to="/tantramassage/frau"
                    >
                        Für die Frau
                    </Link>
                </li>

                <li>
                    <Link
                        className="subnav__link"
                        to="/tantramassage/mann"
                    >
                        Für den Mann
                    </Link>
                </li>

                <li>
                    <Link
                        className="subnav__link"
                        to="/tantramassage/paar"
                    >
                        Für Paare
                    </Link>
                </li>

            </ul>
        </nav>
    );
}

export default TantramassageNavigation;